import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { CallbackPage } from "@/auth/CallbackPage";
import { SilentRenewPage } from "@/auth/SilentRenewPage";
import { DriveShell } from "@/features/shell/DriveShell";
import { DrivePage } from "@/features/drive/DrivePage";
import { RecentPage } from "@/features/drive/RecentPage";
import { FavoritesPage } from "@/features/drive/FavoritesPage";
import { TrashPage } from "@/features/drive/TrashPage";
import { SharedWithMePage } from "@/features/drive/SharedWithMePage";
import { SearchResultsPage } from "@/features/drive/SearchResultsPage";
import { OpenItemPage } from "@/features/drive/OpenItemPage";
import { SharedPage } from "@/features/share/SharedPage";
import { FileRequestPage } from "@/features/share/FileRequestPage";
import { FormPage } from "@/features/share/FormPage";
import { ActivityPage } from "@/features/drive/activity/ActivityPage";
import { StoragePage } from "@/features/drive/storage/StoragePage";

function ProtectedShell() {
    return (
        <ProtectedRoute>
            <DriveShell />
        </ProtectedRoute>
    );
}

export function App() {
    return (
        <Routes>
            <Route path="/auth/callback" element={<CallbackPage />} />
            <Route path="/auth/silent-renew" element={<SilentRenewPage />} />
            {/* Public share landing — anonymous, outside ProtectedRoute. */}
            <Route path="/shared/:token" element={<SharedPage />} />
            {/* Public "Request files" upload page — anonymous, outside ProtectedRoute. */}
            <Route path="/request/:token" element={<FileRequestPage />} />
            {/* Shared form (published from Workbook) — public or sign-in only, outside ProtectedRoute. */}
            <Route path="/forms/:token" element={<FormPage />} />
            <Route element={<ProtectedShell />}>
                <Route path="/" element={<DrivePage />} />
                <Route path="/folder/:folderId" element={<DrivePage />} />
                <Route path="/recent" element={<RecentPage />} />
                <Route path="/favorites" element={<FavoritesPage />} />
                <Route path="/starred" element={<FavoritesPage />} />
                <Route path="/shared-with-me" element={<SharedWithMePage />} />
                <Route path="/trash" element={<TrashPage />} />
                <Route path="/activity" element={<ActivityPage />} />
                <Route path="/storage" element={<StoragePage />} />
                <Route path="/search" element={<SearchResultsPage />} />
                {/* Universal item link (Share dialog, Mail, Connect) — resolves where it lives for the viewer. */}
                <Route path="/open/:itemId" element={<OpenItemPage />} />
            </Route>
        </Routes>
    );
}
